var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"mb-4 welcome",attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.getWelcomeMessage))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }